<style>
#CurvesModal .v--modal-box.v--modal {
  min-height: 600px !important;
  min-width: 400px !important;
}
#CurvesModal .v-card.v-card--flat.v-sheet.theme--light {
  height: 100% !important;
}
#CurvesModal .modal__footer {
  display: none;
}
#CurvesModal .addCurveBtn {
  margin-top: 10px;
  margin-left: 0px;
}
</style>

<template>
  <Modal
    modalName="CurvesModal"
    title="Wzorce i krzywe"
    :buttons="[]"
  >
    <v-tabs
      color="white"
      slider-color="#2a579a"
    >
      <v-tab ripple>
        Krzywe

      </v-tab>
      <v-tab-item>
        <v-card flat>
          <CurvesTable />
          <v-btn
            @click="addCurve"
            class="addCurveBtn"
            color="#2a579a"
            dark
          >DODAJ KRZYWĄ</v-btn>
        </v-card>
      </v-tab-item>

      <v-tab ripple>
        Wzorce
      </v-tab>
      <v-tab-item>
        <v-card flat>
          <PatternsTable />
          <v-btn
            @click="addPattern"
            class="addCurveBtn"
            color="#2a579a"
            dark
          >DODAJ WZORZEC</v-btn>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </Modal>
</template>

<script>
import Modal from '../../../shared/Modal';
import PatternsTable from '../../table/curves/PatternsTable';
import CurvesTable from '../../table/curves/CurvesTable';

export default {
  components: {
    Modal,
    CurvesTable,
    PatternsTable
  },
  data: () => ({
    curvesList: [],
    patternsList: []
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    addCurve() {
      this.show('AddCurvePattern');
      this.$root.$emit('emittingCurveType', true);
    },
    addPattern() {
      this.show('AddCurvePattern');
      this.$root.$emit('emittingCurveType', false);
    }
  }

}
</script>


// WEBPACK FOOTER //
// src/components/viewer/modelWat/modals/CurvesModal.vue